import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/licenseicon.svg'
import _imports_1 from '@/assets/icons/support.svg'
import _imports_2 from '@/assets/icons/forum.svg'
import _imports_3 from '@/assets/icons/tutorial.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"24px","margin-right":"10px"},
  alt: "Release Notes",
  title: "Release Notes"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"24px","margin-right":"10px"},
  alt: "Support",
  title: "Support"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"24px","margin-right":"10px"},
  alt: "Forum",
  title: "Forum"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"24px","margin-right":"10px"},
  alt: "Tutorials",
  title: "Tutorials"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userAuthenticated)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "linkbtn",
          loading: _ctx.loading,
          onClick: _ctx.openReleaseNotes
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_link, {
              class: "linkbtn",
              id: "releasenotes"
            }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createTextVNode(" Release Notes ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, { class: "linkbtn" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_link, {
          class: "linkbtn",
          href: "https://support.visualcomponents.com",
          target: "_blank",
          id: "support"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" Support ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { class: "linkbtn" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_link, {
          class: "linkbtn",
          href: "https://forum.visualcomponents.com/",
          target: "_blank",
          id: "forum"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" Forum ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, { class: "linkbtn" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_link, {
          class: "linkbtn",
          href: "https://academy.visualcomponents.com",
          target: "_blank",
          id: "tutorial"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Tutorial ")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}